// src/components/ResetData.js
import React, { useState } from "react";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../services/firebase";

export default function ResetData() {
  const [loading, setLoading] = useState(false);
  const [log, setLog] = useState([]);
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);

  async function supprimerCollection(colPath) {
    const snap = await getDocs(collection(db, ...colPath.split("/")));
    for (const d of snap.docs) {
      await deleteDoc(doc(db, ...colPath.split("/"), d.id));
    }
    return snap.size;
  }

  async function resetTotal() {
    if (confirm !== "RESET") return;
    setLoading(true);
    setLog([]);
    const addLog = (msg) => setLog((prev) => [...prev, msg]);

    try {
      // Supprimer paiements
      const nbPaiements = await supprimerCollection("paiements");
      addLog(`✅ ${nbPaiements} paiements supprimés`);

      // Supprimer organisations + sous-collections
      const orgsSnap = await getDocs(collection(db, "organisations"));
      for (const orgDoc of orgsSnap.docs) {
        const orgId = orgDoc.id;

        // Tombolas + billets/lots/meta
        const tombolasSnap = await getDocs(collection(db, "organisations", orgId, "tombolas"));
        for (const tombolaDoc of tombolasSnap.docs) {
          const tombolaId = tombolaDoc.id;
          for (const sub of ["billets", "lots", "meta", "statistiques"]) {
            const subSnap = await getDocs(collection(db, "organisations", orgId, "tombolas", tombolaId, sub));
            for (const subDoc of subSnap.docs) {
              await deleteDoc(doc(db, "organisations", orgId, "tombolas", tombolaId, sub, subDoc.id));
            }
          }
          await deleteDoc(doc(db, "organisations", orgId, "tombolas", tombolaId));
        }

        // Membres
        const membresSnap = await getDocs(collection(db, "organisations", orgId, "membres"));
        for (const m of membresSnap.docs) {
          await deleteDoc(doc(db, "organisations", orgId, "membres", m.id));
        }

        await deleteDoc(doc(db, "organisations", orgId));
      }
      addLog(`✅ ${orgsSnap.size} organisations supprimées`);

      // Supprimer profils
      const profilsSnap = await getDocs(collection(db, "profils"));
      for (const d of profilsSnap.docs) {
        await deleteDoc(doc(db, "profils", d.id));
      }
      addLog(`✅ ${profilsSnap.size} profils supprimés`);

      addLog("🎉 Reset complet — base de données prête pour la production !");
      setDone(true);
    } catch (e) {
      addLog(`❌ Erreur : ${e.message}`);
    }
    setLoading(false);
  }

  return (
    <div style={s.wrapper}>
      <div style={s.warning}>
        <div style={s.warningIcon}>⚠️</div>
        <div>
          <h3 style={s.warningTitle}>Zone dangereuse — Reset des données de test</h3>
          <p style={s.warningText}>
            Cette action supprime <strong>définitivement</strong> toutes les organisations, tombolas, billets, lots et paiements de la base de données.
            À utiliser uniquement avant le lancement en production pour nettoyer les données de test.
          </p>
          <p style={s.warningText}>
            <strong>Les comptes utilisateurs Firebase Auth ne sont pas supprimés.</strong>
          </p>
        </div>
      </div>

      {!done && (
        <div style={s.confirmBox}>
          <label style={s.label}>
            Tapez <strong>RESET</strong> pour confirmer :
          </label>
          <input type="text" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            placeholder="RESET" style={s.input} />
          <button onClick={resetTotal} disabled={confirm !== "RESET" || loading} style={{
            ...s.btnReset, opacity: confirm !== "RESET" || loading ? 0.5 : 1
          }}>
            {loading ? "⏳ Suppression en cours…" : "🗑️ Supprimer toutes les données de test"}
          </button>
        </div>
      )}

      {log.length > 0 && (
        <div style={s.logBox}>
          {log.map((line, i) => (
            <div key={i} style={s.logLine}>{line}</div>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  wrapper: { maxWidth: "640px" },
  warning: { display: "flex", gap: "1rem", background: "#fff3e0", border: "2px solid #ff8f00", borderRadius: "12px", padding: "1.5rem", marginBottom: "2rem" },
  warningIcon: { fontSize: "2rem", flexShrink: 0 },
  warningTitle: { fontSize: "1rem", fontWeight: "800", color: "#e65100", margin: "0 0 8px" },
  warningText: { fontSize: "0.88rem", color: "#555", lineHeight: 1.6, margin: "0 0 6px" },
  confirmBox: { background: "#fff", borderRadius: "12px", padding: "1.5rem", border: "1px solid #eee" },
  label: { display: "block", fontSize: "0.9rem", fontWeight: "600", color: "#333", marginBottom: "0.75rem" },
  input: { width: "100%", padding: "0.75rem 1rem", border: "2px solid #e53935", borderRadius: "8px", fontSize: "1rem", outline: "none", marginBottom: "1rem", boxSizing: "border-box", fontFamily: "monospace", letterSpacing: "2px" },
  btnReset: { width: "100%", padding: "0.875rem", background: "linear-gradient(135deg,#c62828,#e53935)", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "800", fontSize: "0.95rem" },
  logBox: { background: "#1a1a2e", borderRadius: "12px", padding: "1.25rem", marginTop: "1.5rem" },
  logLine: { color: "#a5d6a7", fontFamily: "monospace", fontSize: "0.88rem", marginBottom: "6px" },
};
